import React from 'react'
import { Navigate } from 'react-router-dom'

interface DefaultViewRedirectProps {
  isAuthenticated: boolean
}

export default function DefaultViewRedirect({ isAuthenticated }: DefaultViewRedirectProps) {
  // Si l'utilisateur n'est pas authentifié, rediriger vers login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Rediriger toujours vers le dashboard par défaut
  return <Navigate to="/dashboard" replace />
} 